import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=4b3ed09f&scoped=true&"
import script from "./AdminCreate.vue?vue&type=script&lang=js&"
export * from "./AdminCreate.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreate.vue?vue&type=style&index=0&id=4b3ed09f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ed09f",
  null
  
)

export default component.exports